(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class PceSmartHeader extends HTMLElement {
    constructor() {
      super();
      this.lastScrollTop = 0;
      this.accumulatedScroll = 0;
      this.direction = null;
      this.ticking = false;
      this.mobileMenuOpen = false;
    }

    connectedCallback() {
      this.smartHide = this.dataset.smartHide === 'true';
      this.stickyType = this.dataset.stickyType || 'on-scroll-up';
      this.isOverlay = this.classList.contains('pce-site-header--overlay');
      this.isStickyEnabled = this.classList.contains('pce-site-header--sticky');
      this.isAlwaysSticky =
        !this.smartHide &&
        (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size');

      this.lastScrollTop = Math.max(window.scrollY || document.documentElement.scrollTop, 0);
      this.predictiveSearch = this.querySelector('predictive-search');
      this.spacer = this.nextElementSibling?.classList.contains('pce-header-spacer')
        ? this.nextElementSibling
        : null;

      this.mobileMenuToggle = this.querySelector('[data-pce-mobile-menu-toggle]');
      const mobileDrawerId = this.mobileMenuToggle?.getAttribute('aria-controls');
      this.mobileDrawer = mobileDrawerId ? document.getElementById(mobileDrawerId) : null;
      this.mobileDrawerPanel = this.mobileDrawer?.querySelector('[data-pce-mobile-drawer-panel]');
      this.mobileMenuCloseButtons = this.mobileDrawer?.querySelectorAll('[data-pce-mobile-menu-close]') || [];

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.onPointerMoveHandler = this.onPointerMove.bind(this);
      this.onMobileMenuButtonClickHandler = this.toggleMobileMenu.bind(this);
      this.onMobileMenuCloseClickHandler = this.closeMobileMenu.bind(this);
      this.onMobileDrawerClickHandler = this.onMobileDrawerClick.bind(this);
      this.onDocumentKeydownHandler = this.onDocumentKeydown.bind(this);

      this.preventRevealHandler = () => {
        this.preventReveal = true;
        window.clearTimeout(this.preventRevealTimer);
        this.preventRevealTimer = window.setTimeout(() => {
          this.preventReveal = false;
        }, 180);
      };

      this.setHeaderHeight();

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      document.addEventListener('keydown', this.onDocumentKeydownHandler);
      this.addEventListener('preventHeaderReveal', this.preventRevealHandler);

      if (this.mobileMenuToggle && this.mobileDrawer) {
        this.mobileMenuToggle.addEventListener('click', this.onMobileMenuButtonClickHandler);
        this.mobileDrawer.addEventListener('click', this.onMobileDrawerClickHandler);

        this.mobileMenuCloseButtons.forEach((button) => {
          button.addEventListener('click', this.onMobileMenuCloseClickHandler);
        });
      }

      this.pointerMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (this.pointerMediaQuery.matches) {
        window.addEventListener('pointermove', this.onPointerMoveHandler, { passive: true });
      }

      this.updateHeader();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('pointermove', this.onPointerMoveHandler);
      document.removeEventListener('keydown', this.onDocumentKeydownHandler);
      this.removeEventListener('preventHeaderReveal', this.preventRevealHandler);

      if (this.mobileMenuToggle) {
        this.mobileMenuToggle.removeEventListener('click', this.onMobileMenuButtonClickHandler);
      }

      if (this.mobileDrawer) {
        this.mobileDrawer.removeEventListener('click', this.onMobileDrawerClickHandler);
      }

      this.mobileMenuCloseButtons.forEach((button) => {
        button.removeEventListener('click', this.onMobileMenuCloseClickHandler);
      });

      this.closeMobileMenu(false);
      window.clearTimeout(this.preventRevealTimer);
    }

    setHeaderHeight() {
      const rect = this.getBoundingClientRect();
      const height = rect.height || this.offsetHeight;
      if (!height) return;

      const drawerTop = Math.max(rect.bottom, 0);

      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--pce-mobile-drawer-top', `${drawerTop}px`);
    }

    onResize() {
      this.setHeaderHeight();

      if (window.innerWidth >= 990 && this.mobileMenuOpen) {
        this.closeMobileMenu(false);
      }
    }

    toggleMobileMenu() {
      if (this.mobileMenuOpen) {
        this.closeMobileMenu();
      } else {
        this.openMobileMenu();
      }
    }

    openMobileMenu() {
      if (!this.mobileMenuToggle || !this.mobileDrawer || window.innerWidth >= 990) return;

      this.reveal();
      this.mobileMenuOpen = true;
      this.mobileMenuToggle.setAttribute('aria-expanded', 'true');
      this.mobileMenuToggle.setAttribute('aria-label', 'Close menu');
      this.mobileDrawer.setAttribute('aria-hidden', 'false');
      this.mobileDrawer.classList.add('is-open');
      document.documentElement.classList.add('pce-mobile-menu-open');
      document.body.classList.add('pce-mobile-menu-open');

      window.requestAnimationFrame(() => {
        this.setHeaderHeight();
        this.mobileDrawerPanel?.focus({ preventScroll: true });
      });
    }

    closeMobileMenu(returnFocus = true) {
      if (!this.mobileMenuToggle || !this.mobileDrawer) return;

      const wasOpen = this.mobileMenuOpen;
      this.mobileMenuOpen = false;
      this.mobileMenuToggle.setAttribute('aria-expanded', 'false');
      this.mobileMenuToggle.setAttribute('aria-label', 'Open menu');
      this.mobileDrawer.setAttribute('aria-hidden', 'true');
      this.mobileDrawer.classList.remove('is-open');
      document.documentElement.classList.remove('pce-mobile-menu-open');
      document.body.classList.remove('pce-mobile-menu-open');

      this.mobileDrawer.querySelectorAll('details[open]').forEach((details) => {
        details.removeAttribute('open');
      });

      if (returnFocus && wasOpen) {
        this.mobileMenuToggle.focus({ preventScroll: true });
      }
    }

    onMobileDrawerClick(event) {
      const link = event.target.closest('a');

      if (link) {
        this.closeMobileMenu(false);
      }
    }

    onDocumentKeydown(event) {
      if (event.key === 'Escape' && this.mobileMenuOpen) {
        event.preventDefault();
        this.closeMobileMenu();
      }
    }

    onScroll() {
      if (this.ticking) return;

      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.updateHeader();
        this.ticking = false;
      });
    }

    updateHeader() {
      if (this.mobileMenuOpen) {
        this.reveal();
        this.setHeaderHeight();
        this.lastScrollTop = Math.max(window.scrollY || document.documentElement.scrollTop, 0);
        return;
      }

      const scrollTop = Math.max(window.scrollY || document.documentElement.scrollTop, 0);
      const delta = scrollTop - this.lastScrollTop;
      const activationPoint = Math.max(this.offsetHeight + 20, 90);

      if (!this.isStickyEnabled) {
        this.lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= 4) {
        this.accumulatedScroll = 0;
        this.direction = null;
        this.classList.remove('pce-header--scrolled', 'pce-header--hidden');
        this.setSpacer(false);
        this.setHeaderHeight();
        this.lastScrollTop = scrollTop;
        return;
      }

      this.classList.add('pce-header--scrolled');
      this.setSpacer(true);
      this.setHeaderHeight();

      if (this.isAlwaysSticky) {
        this.reveal();
        this.lastScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) {
        this.reveal();
        this.lastScrollTop = scrollTop;
        return;
      }

      if (this.hasOpenInteractiveElement()) {
        this.reveal();
        this.lastScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= activationPoint) {
        this.reveal();
        this.accumulatedScroll = 0;
        this.lastScrollTop = scrollTop;
        return;
      }

      if (delta > 0) {
        if (this.direction !== 'down') {
          this.direction = 'down';
          this.accumulatedScroll = 0;
        }

        this.accumulatedScroll += delta;

        if (this.accumulatedScroll >= 10) {
          this.hide();
          this.accumulatedScroll = 0;
        }
      } else if (delta < 0) {
        if (this.direction !== 'up') {
          this.direction = 'up';
          this.accumulatedScroll = 0;
        }

        this.accumulatedScroll += Math.abs(delta);

        if (this.accumulatedScroll >= 5 && !this.preventReveal) {
          this.reveal();
          this.accumulatedScroll = 0;
        }
      }

      this.lastScrollTop = scrollTop;
    }

    onPointerMove(event) {
      if (!this.isStickyEnabled || this.mobileMenuOpen) return;
      if (event.clientY > 28) return;
      if (window.scrollY <= this.offsetHeight) return;

      this.classList.add('pce-header--scrolled');
      this.setSpacer(true);
      this.reveal();
      this.setHeaderHeight();
    }

    setSpacer(active) {
      if (!this.spacer || this.isOverlay) return;
      this.spacer.classList.toggle('is-active', active);
    }

    hasOpenInteractiveElement() {
      return Boolean(
        this.mobileMenuOpen ||
        this.querySelector(
          'details[open], .menu-opening, predictive-search[open], details-modal[open]'
        )
      );
    }

    hide() {
      if (this.isAlwaysSticky || this.hasOpenInteractiveElement()) return;

      this.classList.add('pce-header--hidden', 'pce-header--scrolled');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.classList.remove('pce-header--hidden');
    }

    closeMenuDisclosure() {
      const disclosures = this.querySelectorAll('header-menu');

      disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') {
          disclosure.close();
        }
      });
    }

    closeSearchModal() {
      const searchModal = this.querySelector('details-modal');

      if (searchModal && typeof searchModal.close === 'function') {
        searchModal.close(false);
      }
    }
  }

  if (!customElements.get('pce-smart-header')) {
    customElements.define('pce-smart-header', PceSmartHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
